import contact from './Contact_4775x2734.jpg';
import repair from './GlassRepair_5616x3744.jpg';
import home from './Home.jpeg';
import logo from './Logo.png';
import maintenance from './Maintenance_4000x2667.jpg';
import navigation from './Navigation_6000x4000.jpg';
import tinted from './Tinted.jpg';

const images = { logo, repair, maintenance, tinted, home, contact, navigation };
Object.freeze(images);

export type ExistingImages = keyof typeof images | null;
export default images;
